import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";

import { Lookup } from '../models/admin-models/lookup.model';
import { Filter } from '../models/filter.model';

@Injectable({
    providedIn: 'root'
})
export class QuestionnarieGroupService {

    constructor(private httpClient: HttpClient) { }

    getOne(id: Number) {
        return this.httpClient.get('api/questionnairegroups/' + id).toPromise();
    }

    boxView() {
        return this.httpClient.get('api/questionnairegroups')
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    gridView(filter: Filter) {
        return this.httpClient.post('api/questionnairegroups/gridview', filter.data)
            .pipe(
                map((res: any) => {
                    return res;
                }),
                catchError((error) => {
                    return throwError(error);
                })
            )
    }

    createQuestionnarieGroup(lookup: Lookup) {
        return this.httpClient.post('api/questionnairegroups/create', lookup.data).toPromise();
    }

    editQuestionnarieGroup(lookup: Lookup) {
        return this.httpClient.post('api/questionnairegroups/edit', lookup.data).toPromise();
    }

    deleteQuestionnarieGroup(ids: Array<Number>) {
        return this.httpClient.post('api/questionnairegroups/delete', ids).toPromise();
    }

}